<template>
    <div>
        <div class="container" v-if="currentStep.showNavigation">
            <Navigation />
        </div>
        <modelSelect v-show="currentStep.step === 'modelSelect'" />
        <div class="container">
            <DealerSelect v-if="currentStep.step === 'dealerSelect'" />
            <DateSelect v-if="currentStep.step === 'dateSelect'" />
            <Details v-if="currentStep.step === 'details'" />
            <Details v-if="currentStep.step === 'confirmation'" />
        </div>
    </div>
</template>

<script>
import { mapGetters,  mapState } from "vuex";
import Navigation from "./Navigation.vue";
import ModelSelect from "./steps/ModelSelect.vue";
import DealerSelect from "./steps/DealerSelect.vue";
import DateSelect from "./steps/DateSelect.vue";
import Details from "./steps/Details.vue";

export default {
    components: { Navigation, ModelSelect, DealerSelect, DateSelect, Details },
    mounted() {
        if(this.deepLinkData !== null){
            this.$store.dispatch('getVehicle', this.deepLinkData.model)
            this.$store.dispatch("navigatorStep", this.deepLinkData.page);
        }
    },
    computed: {
        ...mapState([
            'deepLinkData',
        ]),
        ...mapGetters(["currentStep"]),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/cms-content-slices/components/electric-test-drive/ElecTestDrive.vue